/*
 * This file is part of glowingblue/datavis.
 *
 * Copyright (c) 2022 Glowing Blue AG.
 * Authors: Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import Component from 'flarum/common/Component';
import Stream from 'flarum/common/utils/Stream';

export default class Tabs extends Component {
	oninit(vnode) {
		super.oninit(vnode);

		this.active = new Stream(0);
	}

	view() {
		const { _children = [], ChildComponent } = this.attrs;

		const tabWidth = 100 / _children.length;
		const sliderTransform = `translateX(${this.active() * 100}%)`;

		return (
			<div className='Tabs' style={{ '--tab-width': `${tabWidth}%` }}>
				<div className='Tabs-nav--container'>
					<ul className='Tabs-nav'>
						{_children.map((child, index) => (
							<li
								className={`Tabs-navItem${
									this.active() === index ? ' is-active' : ''
								}`}>
								<label role='button' onclick={() => this.active(index)}>
									<br />
									<span>{child.name()}</span>
								</label>
							</li>
						))}
					</ul>

					<div className='Tabs-slider' style={{ transform: sliderTransform }}>
						<div className='Tabs-indicator'></div>
					</div>
				</div>

				<div className='Tabs-content'>
					{_children.map((child, index) => (
						<ChildComponent active={this.active() === index} data={child} />
					))}
				</div>
			</div>
		);
	}
}
